import { render, staticRenderFns } from "./SlideItemLast.vue?vue&type=template&id=37f8cfd0&scoped=true&"
import script from "./SlideItemLast.vue?vue&type=script&lang=js&"
export * from "./SlideItemLast.vue?vue&type=script&lang=js&"
import style0 from "./SlideItemLast.vue?vue&type=style&index=0&id=37f8cfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8cfd0",
  null
  
)

export default component.exports